import React from 'react'
import { Link } from "gatsby"
import { NavLink } from "theme-ui"

const GatbsyNavLink = (props) => (
    <NavLink as={AsLink} activeClassName="active" to={props.href}>
        {props.children}
    </NavLink>
)

function AsLink(props) {
    return <Link activeClassName="active" {...props} />;
}

export default GatbsyNavLink